import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PageBreadcrumbs from '../PageBreadcrumbs'

function PageHeader({ title, subtitle, status, entities, actions, children }) {
  return (
    <Box sx={{ width: "100%", p: 2, borderBottom: 1, borderColor: 'divider' }}>
      <PageBreadcrumbs entities={entities} />
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, gap: { xs: 1, sm: 0 }, mb: children ? 2 : 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {status}
          <Box>
            <Typography variant="h1" component="h1">
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'monospace' }}>
                {subtitle}
              </Typography>
            )}
          </Box>
        </Box>
        {actions && (
          <Box sx={{ display: 'flex', gap: 2 }}>
            {actions}
          </Box>
        )}
      </Box>
      {children}
    </Box>
  )
}

export default PageHeader
